import type { ProjectTab } from "./ProjectTabs";
import { ProjectDebugChatTab } from "./tabs/ProjectDebugChatTab";
import { ProjectDeploysTab } from "./tabs/ProjectDeploysTab";
import { ProjectInspectorTab } from "./tabs/ProjectInspectorTab";
import { ProjectObservabilityTab } from "./tabs/ProjectObservabilityTab";
import { ProjectOverviewTab } from "./tabs/ProjectOverviewTab";

interface ProjectTabContentProps {
  projectId: string;
  activeTab: ProjectTab;
}

export function ProjectTabContent({
  projectId,
  activeTab,
}: ProjectTabContentProps) {
  const tabContentProps = { projectId };

  return (
    <div
      role="tabpanel"
      id={`tabpanel-${activeTab}`}
      aria-labelledby={`tab-${activeTab}`}
      className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-lg"
    >
      {activeTab === "overview" && <ProjectOverviewTab {...tabContentProps} />}
      {activeTab === "inspector" && (
        <ProjectInspectorTab {...tabContentProps} />
      )}
      {activeTab === "observability" && (
        <ProjectObservabilityTab {...tabContentProps} />
      )}
      {activeTab === "debug-chat" && (
        <ProjectDebugChatTab {...tabContentProps} />
      )}
      {activeTab === "deploys" && <ProjectDeploysTab {...tabContentProps} />}
    </div>
  );
}
